import { Link } from "@/components/common/Link";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function TickerConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="flex items-center h-full px-4">
        <div className="h-2 w-32 bg-white/10 animate-pulse rounded-md" />
      </div>;
  }
  if (error || !posts || posts.length === 0) {
    return <div className="flex items-center h-full px-4">
        <span className="text-[10px] font-sans uppercase tracking-widest text-white/50">
          Tidak ada berita terbaru
        </span>
      </div>;
  }
  return <div className="flex items-center h-full w-full overflow-hidden">
      {}
      <div className="flex items-center gap-2 px-4 bg-black z-10 h-full border-r border-white/10 shrink-0">
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-lg bg-red-500 opacity-75"></span>
          <span className="relative inline-flex rounded-lg h-2 w-2 bg-red-600"></span>
        </span>
        <span className="text-[10px] font-bold text-red-600 uppercase tracking-tighter">
          LIVE
        </span>
      </div>

      {}
      <div className="relative flex-1 overflow-hidden h-full flex items-center group">
        <style>
          {`
            @keyframes ticker-scroll {
              0% { transform: translateX(0); }
              100% { transform: translateX(-50%); }
            }
            .animate-ticker {
              display: flex;
              white-space: nowrap;
              animation: ticker-scroll 25s linear infinite;
            }
            .animate-ticker:hover {
              animation-play-state: paused;
            }
          `}
        </style>
        <div className="animate-ticker">
          {}
          {[...posts, ...posts].map((post, i) => <div key={`${post.id}-${i}`} data-index={i} className="flex items-center">
              <Link to={post.link || "#"} className="text-[11px] font-sans text-white hover:text-primary transition-colors px-6 truncate max-w-[300px] md:max-w-[500px]">
                {post.title}
              </Link>
              <span className="text-white/30 text-[10px]">•</span>
            </div>)}
        </div>
      </div>
    </div>;
}
export default function Livenewstickerbar() {
  const wp_query_params = {
    post_type: "post",
    per_page: 10,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="1913" id="livenewstickerbar" className="fixed z-50 w-full h-[40px] bg-black overflow-hidden flex items-center top-[64px] sm:top-[68px] lg:top-[80px]">
      <PostsProvider wp_query={{
      post_type: "post",
      per_page: 10,
      order: "desc",
      orderby: "date",
      status: ["publish"]
    }} className="w-full h-full">
        <TickerConsumer />
      </PostsProvider>
    </section>;
}